import { strToU8, zipSync } from "fflate";
import type { EvaluationResult } from "../model/types";

function escapeXml(value: string): string {
  return value.replace(/[<>&"']/g, (character) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;", "'": "&apos;" })[character] ?? character);
}

export function createThreeMf(evaluation: EvaluationResult, modelName: string): Blob {
  if (evaluation.bodies.length === 0) throw new Error("There are no valid bodies to export");
  const objects = evaluation.bodies.map((body, bodyIndex) => {
    const vertices: string[] = [];
    for (let index = 0; index < body.vertices.length; index += 3) {
      vertices.push(`<vertex x="${body.vertices[index] ?? 0}" y="${body.vertices[index + 1] ?? 0}" z="${body.vertices[index + 2] ?? 0}"/>`);
    }
    const triangles: string[] = [];
    for (let index = 0; index < body.triangles.length; index += 3) {
      triangles.push(`<triangle v1="${body.triangles[index] ?? 0}" v2="${body.triangles[index + 1] ?? 0}" v3="${body.triangles[index + 2] ?? 0}"/>`);
    }
    return `<object id="${bodyIndex + 1}" type="model" name="${escapeXml(body.name)}"><mesh><vertices>${vertices.join("")}</vertices><triangles>${triangles.join("")}</triangles></mesh></object>`;
  });
  const buildItems = evaluation.bodies.map((_body, index) => `<item objectid="${index + 1}"/>`).join("");
  const modelXml = `<?xml version="1.0" encoding="UTF-8"?>
<model unit="millimeter" xml:lang="en-US" xmlns="http://schemas.microsoft.com/3dmanufacturing/core/2015/02">
  <metadata name="Title">${escapeXml(modelName)}</metadata>
  <metadata name="Application">ModelMotive 0.1.0</metadata>
  <resources>${objects.join("")}</resources>
  <build>${buildItems}</build>
</model>`;
  const contentTypes = `<?xml version="1.0" encoding="UTF-8"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="model" ContentType="application/vnd.ms-package.3dmanufacturing-3dmodel+xml"/></Types>`;
  const relationships = `<?xml version="1.0" encoding="UTF-8"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Target="/3D/3dmodel.model" Id="rel0" Type="http://schemas.microsoft.com/3dmanufacturing/2013/01/3dmodel"/></Relationships>`;
  const archive = zipSync({
    "[Content_Types].xml": strToU8(contentTypes),
    "_rels/.rels": strToU8(relationships),
    "3D/3dmodel.model": strToU8(modelXml)
  });
  return new Blob([archive], { type: "model/3mf" });
}
